"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-underscore-dangle */
const core_1 = require("@angular/core");
const moment_1 = __importDefault(require("moment"));
const custom_1 = require("../shared/models/templates/custom");
const config_service_1 = require("../../../shared/config/config.service");
const enums_1 = require("../@shared-types/print/enums");
const users_service_1 = require("../../../shared/users/users.service");
const toast_service_1 = require("../../../ui-components/toast/toast.service");
const interface_service_1 = require("../../../shared/interface/interface.service");
const customer_1 = require("../shared/models/customer/customer");
const dummy_1 = __importDefault(require("../shared/models/vehicle/dummy"));
const tab_service_1 = require("../../../shared/browser-functions/tab.service");
const object_1 = __importDefault(require("../shared/services/object"));
/** This component will create or modify a `CustomTemplate`.
 * All `BuildingBlock`s are separated into their own components. */
let CustomTemplateFormComponent = class CustomTemplateFormComponent {
    constructor(customTemplateModel, configService, usersService, toastService, interfaceService, customerModel, dummyVehicle, tabService, objectService) {
        this.customTemplateModel = customTemplateModel;
        this.configService = configService;
        this.usersService = usersService;
        this.toastService = toastService;
        this.interfaceService = interfaceService;
        this.customerModel = customerModel;
        this.dummyVehicle = dummyVehicle;
        this.tabService = tabService;
        this.objectService = objectService;
        this.mode = 'NEW';
        this.template = null;
        this.addBlockType = enums_1.EBuildingBlocks.TITLE;
        this.editBlock = null;
        this.activeEditComponent = null;
        this.showAppendixUpload = false;
        this.sending = false;
        this.twoStepDelete = false;
        this.templateBackground = {};
        this.previewVehicleId = null;
        this.generatingPreview = false;
        /** Either get currently selected customTemplate
         * or add a new one. */
        this.init = (templateId) => __awaiter(this, void 0, void 0, function* () {
            const subsidiary = this.usersService.getMainSubsidiary();
            if (subsidiary) {
                const { footer, header } = subsidiary.config.templates;
                if (header)
                    this.templateBackground.header = header;
                if (footer)
                    this.templateBackground.footer = footer;
            }
            if (this.mode === 'EDIT' && templateId) {
                this.template = yield this.customTemplateModel.get(templateId);
                return;
            }
            this.template = this.customTemplateModel.templateStub();
        });
        /** Is called by any of the `BuildingBlock`s. Every Block component
         * has a UUID, which we receive here. We save the UUID and give it to
         * all blocks to signalize which block is being edited right now. */
        this.onBlockEdit = (data) => {
            this.editBlock = data.block;
            this.activeEditComponent = data.componentUuid;
        };
        this.hideEditBlock = () => {
            this.editBlock = null;
        };
        this.deleteBlock = (index) => {
            if (!this.template)
                return;
            this.template.blocks.splice(index, 1);
        };
        /**
         * We do not need to check every `BuildingBlock` for validity,
         * because they will be initialized with a complete type. If a text input
         * for example is empty, the empty string will be saved nevertheless.
         */
        this.submitForm = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.template)
                return;
            /** Fix for mongodb saving undefined as null */
            if (this.template.createTask === null)
                delete this.template.createTask;
            try {
                this.sending = true;
                if (this.mode === 'NEW') {
                    const template = yield this.customTemplateModel.post(this.template);
                    this.interfaceService.navigateToUrl(`/settings/custom-templates/edit/${String(template._id)}`);
                }
                else {
                    yield this.customTemplateModel.put(this.template);
                }
                this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'Vorlage gespeichert.');
                this.sending = false;
            }
            catch (e) {
                console.error(e);
                this.toastService.toast(toast_service_1.ToastType.ERROR, 'Fehler beim Speichern der Vorlage.');
                this.sending = false;
            }
        });
        /** Callback from `StaticUploadComponent` to inform if the upload
         * was successfull or not. It returns the staticId on success. */
        this.finishAppendixUpload = (data) => {
            if (this.template && data.$event) {
                this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'Anhang erfolgreich hochgeladen.');
                this.template.appendix = data.$event;
            }
            this.showAppendixUpload = false;
        };
        this.deleteAppendix = () => {
            if (!this.template)
                return;
            this.template.appendix = null;
        };
        this.moveBlock = (index, direction) => {
            if (!this.template)
                return;
            const { blocks } = this.template;
            const toIndex = index + direction;
            if (index < 0 || index >= blocks.length || toIndex < 0 || toIndex >= blocks.length)
                return;
            const [movedElement] = blocks.splice(index, 1);
            blocks.splice(toIndex, 0, movedElement);
        };
        this.deleteTemplate = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.template || !this.template._id)
                return;
            try {
                this.sending = true;
                yield this.customTemplateModel.delete(String(this.template._id));
                this.toastService.toast(toast_service_1.ToastType.SUCCESS, 'Vorlage wurde gelöscht.');
                this.interfaceService.navigateToUrl('/settings/custom-templates');
            }
            catch (e) {
                this.sending = false;
                console.error(e);
                this.toastService.toast(toast_service_1.ToastType.ERROR, 'Fehler beim Löschen der Vorlage.');
            }
        });
        /** For the current template: Generate and download a
         * document with exampe data for vehicle and customer. */
        this.getDocumentPreview = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.template)
                return;
            this.generatingPreview = true;
            if (!this.previewVehicleId) {
                this.previewVehicleId = yield this.dummyVehicle.createRandomDummyVehicle();
            }
            const req = Object.assign(Object.assign({}, this.template), { customer: this.customerModel.getExample(), vehicleId: this.previewVehicleId, dummyVehicle: true, createTask: undefined });
            const res = yield this.customTemplateModel.createDocument(req);
            const fileName = `${(0, moment_1.default)().format('YYYY-MM-DD')}-vorschau.pdf`;
            this.tabService.downloadBlob(res, fileName);
            this.generatingPreview = false;
        });
        this.copyTemplate = () => __awaiter(this, void 0, void 0, function* () {
            if (this.mode === 'NEW' || !this.template)
                return;
            this.sending = true;
            const stub = {
                addToOpportunity: this.template.addToOpportunity,
                appendix: this.template.appendix,
                blocks: this.template.blocks,
                title: `${this.template.title} (Kopie)`,
            };
            const template = yield this.customTemplateModel.post(stub);
            this.interfaceService.navigateToUrl(`/settings/custom-templates/edit/${String(template._id)}`);
            this.sending = false;
        });
        const { templateId } = this.configService.getRouteParams();
        this.mode = templateId ? 'EDIT' : 'NEW';
        this.init(templateId);
    }
};
CustomTemplateFormComponent = __decorate([
    (0, core_1.Component)({
        selector: 'custom-template-form',
        templateUrl: require('./custom-template-form.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof custom_1.CustomTemplateModel !== "undefined" && custom_1.CustomTemplateModel) === "function" ? _a : Object, typeof (_b = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _b : Object, typeof (_c = typeof users_service_1.UsersService !== "undefined" && users_service_1.UsersService) === "function" ? _c : Object, typeof (_d = typeof toast_service_1.ToastService !== "undefined" && toast_service_1.ToastService) === "function" ? _d : Object, typeof (_e = typeof interface_service_1.InterfaceService !== "undefined" && interface_service_1.InterfaceService) === "function" ? _e : Object, typeof (_f = typeof customer_1.CustomerModel !== "undefined" && customer_1.CustomerModel) === "function" ? _f : Object, typeof (_g = typeof dummy_1.default !== "undefined" && dummy_1.default) === "function" ? _g : Object, typeof (_h = typeof tab_service_1.TabService !== "undefined" && tab_service_1.TabService) === "function" ? _h : Object, typeof (_j = typeof object_1.default !== "undefined" && object_1.default) === "function" ? _j : Object])
], CustomTemplateFormComponent);
exports.default = CustomTemplateFormComponent;
